import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { ColorField } from "app/pages/presentation/module/form/types";
import Div from "@jumbo/shared/Div";
import {
  COLOR_FIELD_KEYS,
  getColorLabelKey,
} from "app/pages/customers/dsok/smartkioskFields/colorsFieldConfig";

const FIELD_NAME = "SMARTKIOSK_COLORS";

/**
 * Shared grid of color fields. Same items everywhere (customer-detail colors
 * and system settings new-customer colors). Each page uses its own Formik
 * and data source (separate controls).
 */
export function ColorsFieldsGrid({ namePrefix = "colors" }) {
  const { t, i18n } = useTranslation();
  return (
    <Grid container spacing={2}>
      {COLOR_FIELD_KEYS.map((key) => (
        <Grid item xs={12} md={4} lg={2} key={key}>
          <Div sx={{ mt: 1, mb: 1 }}>
            <ColorField
              name={`${namePrefix}.${key}`}
              lang={i18n.language}
              parameters={{
                label: {
                  [i18n.language]: t(getColorLabelKey(key)),
                },
                required: true,
              }}
            />
          </Div>
        </Grid>
      ))}
    </Grid>
  );
}

const SmartkioskColors = ({
  handleChange,
  expanded,
  hideSectionTitle = false,
}) => {
  const { t } = useTranslation();
  const content = <ColorsFieldsGrid namePrefix="colors" />;

  if (hideSectionTitle) {
    return content;
  }

  return (
    <Accordion
      expanded={expanded === FIELD_NAME}
      onChange={handleChange(FIELD_NAME)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ width: "33%", flexShrink: 0 }}>
          {t("pages.dsokDetails.colors.colorsTitle")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{content}</AccordionDetails>
    </Accordion>
  );
};

export default SmartkioskColors;
